import { render, staticRenderFns } from "./SurveyConfirmation.vue?vue&type=template&id=264eaf4d&"
import script from "./SurveyConfirmation.vue?vue&type=script&lang=ts&"
export * from "./SurveyConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports